var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',[_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')])])
}]

export { render, staticRenderFns }